import { render, staticRenderFns } from "./DefaultContainer.vue?vue&type=template&id=61f39510&"
import script from "./DefaultContainer.vue?vue&type=script&lang=js&"
export * from "./DefaultContainer.vue?vue&type=script&lang=js&"
import style0 from "./DefaultContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports